import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import PauseIcon from '@mui/icons-material/Pause';
import IconButton from './IconButton';
import logger from '../utils/logger';

function SoundPlayer() {
  const { t } = useTranslation();
  const { speakerDeviceId } = useSelector((state) => state.device);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const playSound = async () => {
    if (audioRef.current) {
      if (isPlaying) {
        // Stop the audio if it's currently playing
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      } else {
        // Start playing audio
        audioRef.current.play();
        // setIsPlaying(true);
      }
      return;
    }

    // Create a new audio element and set it up
    const audio = new Audio('/test.wav');

    if (audio.setSinkId && speakerDeviceId) {
      try {
        await audio.setSinkId(speakerDeviceId);
      } catch (error) {
        logger.error('Error setting audio output device:', error);
      }
    }

    audio.addEventListener('play', () => setIsPlaying(true));
    audio.addEventListener('pause', () => setIsPlaying(false));
    audio.addEventListener('ended', () => setIsPlaying(false));

    audioRef.current = audio;
    audio.play();
  };

  useEffect(() => {
    // Stop the sound if speakerDeviceId changes
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }
  }, [speakerDeviceId]);

  return (
    <Stack alignItems="center" width="100px">
      <IconButton
        onClick={playSound}
        aria-label={isPlaying ? t('Stop test sound') : t('Play test sound')}
        aria-pressed={isPlaying}
      >
        {isPlaying ? (
          <PauseIcon
            sx={(theme) => ({
              color: theme.palette.secondary.main,
            })}
          />
        ) : (
          <PlayArrowOutlinedIcon
            sx={(theme) => ({
              color: theme.palette.secondary.main,
            })}
          />
        )}
      </IconButton>
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '12px', // Adjust font size as needed
        }}
      >
        {t('Test sound')}
      </Typography>
    </Stack>
  );
}

export default SoundPlayer;
